<template>
  <div v-if="branch">
    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">Name</label>
      </div>
      <div class="field-body">
        <div class="field">
          <p class="control">
            <input v-model="branch.branch" type="text" class="input oc-input" />
          </p>
        </div>
      </div>
    </div>
    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">Code</label>
      </div>
      <div class="field-body">
        <div class="field">
          <p class="control">
            <input v-model="branch.code" type="text" class="input oc-input" />
          </p>
        </div>
      </div>
    </div>
    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">Name</label>
      </div>
      <div class="field-body">
        <div class="field">
          <p class="control">
            <input v-model="branch.name" type="text" class="input oc-input" />
          </p>
        </div>
      </div>
    </div>
    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">Address</label>
      </div>
      <div class="field-body">
        <div class="field">
          <p class="control">
            <input v-model="branch.address" type="text" class="input oc-input" />
          </p>
        </div>
      </div>
    </div>
    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">Description</label>
      </div>
      <div class="field-body">
        <div class="field">
          <p class="control">
            <input v-model="branch.description" type="text" class="input oc-input" />
          </p>
        </div>
      </div>
    </div>
    <div class="field is-horizontal">
      <div class="field-label is-normal">
      </div>
      <div class="field-body">
        <div class="field">
          <p class="control">
            <label class="checkbox">
                <input type="checkbox" v-model="branch.isDemo">
                Demo branch
            </label>
          </p>
        </div>
      </div>
    </div>

    <div class="field">
      <div class="control">
        <button class="button is-success" @click="save()">Save</button>
      </div>
    </div>
  </div>
</template>
<script>
  import branchService from "../../../../services/branch.service"
  import clientService from "../../../../services/client.service"

  export default {
    name: 'branch-create',
    data() {
      return {
        branch: {}
      }
    },
    computed: {
      clientId() {
        return Number(this.$route.params.clientId);
      }
    },
    methods: {
      async save() {
        this.branch.clientId = this.clientId;
        this.branch = await branchService.create(this.branch);
        this.$router.push({ name: 'branch-list', params: { clientId: this.clientId } });
      }
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/branches/create.vue